export default "__VITE_ASSET__NW8xBeLJ__"